<template>
        <div class="crm-entry-buttons primary">
            <div class="v-flex w-100 pl-3 pr-3">
                <!-- edit entry -->
                <div v-if="entry.id !== null && !entry.deleted">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                @click = "onEdit"
                                v-bind = "attrs"
                                v-on   = "on"
                            >
                                <v-icon small color="white"  class="toolbar-button">fas fa-pen</v-icon>
                            </a>
                        </template>
                        <span>{{ $t("crm.menu.edit") }}</span>
                    </v-tooltip>
                </div>
                <!-- edit entry -->

                <!-- show document -->
                <div v-if="entry.id !== null && (isDocument || isMail)" class="ml-0">
                    <v-tooltip bottom  >
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                v-bind = "attrs"
                                v-on   = "on"
                                @click = "onDocument"
                            >
                                <v-icon small color="white" class="toolbar-button pl-1">fas fa-file</v-icon>
                            </a>
                        </template>
                        <span>{{ $t("crm.menu.document") }}</span>
                    </v-tooltip>
                </div>
                <!-- show document -->

                <v-spacer/>

                <!-- delete entry -->
                <div v-if="entry.id !== null && !entry.deleted">
                    <v-tooltip bottom >
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                @click = "onDelete"
                                v-bind = "attrs"
                                v-on   = "on"
                            >
                                <v-icon color="white"  class="toolbar-button">fa fa-trash-alt</v-icon>
                            </a>
                        </template>
                        <span>{{ $t("crm.menu.delete") }}</span>
                    </v-tooltip>
                </div>
                <!-- delete entry -->

                <!-- undelete entry -->
                <div v-if="entry.deleted">
                    <v-tooltip bottom >
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                @click = "onUnDelete"
                                v-bind = "attrs"
                                v-on   = "on"
                            >
                                <v-icon color="white"  class="toolbar-button">fa fa-undo-alt</v-icon>
                            </a>
                        </template>
                        <span>{{ $t("crm.menu.undelete") }}</span>
                    </v-tooltip>
                </div>
                <!-- undelete entry -->

            </div>
        </div>
</template>

<script>

import Dms from "@/modules/dms/common/service/Dms";
import Crm from "@/modules/crm/service/Crm.ts";

export default {
    name: "CrmEntryMenu",

    components: {
    },

    props: {
        entry: {
            required: true
        }
    },

    data () {
        return {
        }
    },

    computed: {
        isDocument () {
            return this.entry.type.id === Crm.journal.type.document;
        },
        isMail () {
            return this.entry.type.id === Crm.journal.type.email;
        },
    },

    methods: {
        onEdit() {
            this.$emit(Crm.events.edit);
        },

        onDelete () {
            this.$emit(Crm.events.delete, true)
        },

        onUnDelete () {
            this.$emit(Crm.events.undelete, true)
        },

        onDocument () {
            Dms.open(this.entry.dmsId);
        },
    }
}
</script>

<style scoped>

.crm-entry-buttons {
    width: 100%;
    height: 28px;
    margin-bottom: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}

</style>